import { Image, TokenDataList } from '../../../shared/shared.interface';
export interface KngBanner {
  state: KngBannerState;
}
export interface KngBannerState {
  bannerIcon: Image;
  bannerMessage: string;
  tokenData?: DataPair[];
  closeIcon: Image;
  open: boolean;
  isAddNewUserScreen?: boolean;
  alertBanner?: AlertBanner[];
  startDate: Date;
  endDate: Date;
}
export interface ReviewListBannerState {
  open: boolean;
  bannerIcon: Image;
  closeIcon: Image;
  bannerMessage: string;
  startDate: Date;
  endDate: Date;
}
export interface DataPair {
  label: string;
  value: string;
  href?: string;
  icon?: string;
  altText?: string;
  cardCategory?: string;
  tokenDataList?: TokenDataList[];
}
export interface AlertBanner {
  display: string;
  bannerIcon: Image;
  closeIcon: Image;
  hasTokenInMessage: string;
  bannerMessage: string;
  tokenDataList: TokenDataList[];
  startDate: Date;
  endDate: Date;
  showModal?: boolean;
}
